
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ShowFiles',
  props: {
    comment: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    function countFiles(files: any[]): number {
      if (!files) {
        return 0;
      }

      const allowedExtensions = ['pdf', 'docx', 'xlsx', 'pptx', 'vnd'];
      let count = 0;

      files.forEach(file => {
        const type = file.originalName.split('.')[file.originalName.split('.').length - 1];

        if (allowedExtensions.includes(type)) {
          count++;
        }
      });

      return count;
    }

    const formatSize = (size: number) => {
      const mb = size / (1024 * 1024);
      return `${mb.toFixed(2)}MB`;
    };

    return {
      countFiles,
      formatSize,
    };
  },
});
